import { Stack } from '@mui/material';
import { useState } from 'react';

import { Button } from '@/components/form/baseInputs/Button';

import { SmartReviewStepFooterProps } from '../../SmartReviewOnboardingModal.types';

/**
 * Footer for the "SmartReview" step: Previous to return to the previous step,
 * and Continue to set the household's SmartReview enable flag and advance to
 * presentation selection. Both actions are on the right, the same as other
 * multi-step trowser footers.
 */
export function SmartReviewOptionFooter({
  onAdvance,
  onBack,
}: SmartReviewStepFooterProps) {
  const [isContinuing, setIsContinuing] = useState(false);

  const handleContinue = async () => {
    setIsContinuing(true);
    try {
      await onAdvance();
    } finally {
      setIsContinuing(false);
    }
  };

  return (
    <Stack direction="row" justifyContent="flex-end" gap={1} width="100%">
      <Button
        variant="secondary"
        size="sm"
        onClick={onBack}
        disabled={isContinuing}
      >
        Previous
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={handleContinue}
        loading={isContinuing}
      >
        Continue
      </Button>
    </Stack>
  );
}
